<div *ngIf="user">
<p>Hello</p>
